import { ApolloError } from '@apollo/client';
import { AddCrewChangeRequestError } from '@bechtel/types';

export enum AddCrewChangeRequestCustomError {
  ORIGIN_FM_SAME_AS_DEST_FM = 'ORIGIN_FM_SAME_AS_DEST_FM',
  ORIGIN_GF_SAME_AS_DEST_GF = 'ORIGIN_GF_SAME_AS_DEST_GF',
  USER_NOT_IN_ORIGIN_DEST = 'USER_NOT_IN_ORIGIN_DEST',
}

export type AddCrewChangeRequestErrorExt = AddCrewChangeRequestError | AddCrewChangeRequestCustomError | ApolloError;

export interface CrewChangeRequestErrorProps {
  addCrewChangeError: AddCrewChangeRequestErrorExt;
  close: () => void;
}
